import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { NavigationShell } from '../../shared/navigation_shell/navigation_shell';
import * as storeActions from '../../data/reducers/store.reducer';
import { AppDispatch } from '../../data/storeConfig';
import { useDispatch, useSelector } from 'react-redux';
import placeholder from '../../assets/placeholder/product_placeholder.png';
import { constants } from '../../config';
import { Picture, SupplierDetails } from '../../data/models/product_list_response';
import { RootState } from '../../data/reducers';
import { formatAmount } from '../../utility/common';
import { ProductAddButton } from '../../shared/components/product_components/product_add_button';
import { ImageComponent } from '../../shared/components/common/image_component';
import { ProductVariantAddButton } from '../../shared/components/product_components/product_variant_add_button';
import { icons } from '../../assets/assets';
import SupplierDetailsModal from '../../shared/components/common/supplier_details';
import CarouselItem from './carousel_item';

export const ProductDetail = () => {
  const { storeSlug, productId } = useParams<any>();
  let url = placeholder;

  const { storeProduct } = useSelector((rootState: RootState) => rootState.storeReducer);

  const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    dispatch(storeActions.fetchStoreProductInfo({ storeSlug: `${storeSlug}`, productId: `${productId}` }));
  }, []);

  const getImageUrl = (file: Picture) => {
    url = `${constants.API}/media/MediaContent?filePath=${file.filePath}&fileName=${file.fileName}`;

    return url;
  };

  return (
    <NavigationShell title="Product" isBackVisible={true}>
      <div className="-mt-14 overflow-x-clip">
        <div className="carousel carousel-center w-[95%] p-4 space-x-4 bg-neutral rounded-box">
          {storeProduct?.productPictures?.length > 0 ? (
            storeProduct?.productPictures?.map((picture: Picture) => <CarouselItem key={''} picture={picture} />)
          ) : (
            <div className="carousel-item w-full" key={''}>
              <ImageComponent
                src={''}
                htmlClass="object-cover max-w-lg mx-auto w-full h-72 rounded-box"
                htmlAlt="product-image"
              />
            </div>
          )}
        </div>
        <div className="mx-6 text-left py-4">
          <h4 className="text-theLighterDark text-sm uppercase">{storeProduct.manufacturer}</h4>
          <h2 className="text-theDarkOne text-lg font-medium mt-2">{storeProduct?.productName}</h2>
          {storeProduct.suppliersDetails?.map((supplier: SupplierDetails) => (
            <SupplierDetailsModal key={supplier.userId} {...supplier} />
          ))}
          {!storeProduct.haveVariants && (
            <>
              <p className="text-theLighterDark mt-2">{`In stock: ${storeProduct?.quantity} ${storeProduct?.productUnit?.productUnitName}`}</p>
              <p className="text-primaryViolet mt-2 font-medium mb-4">{formatAmount(storeProduct?.sellingPrice)}</p>
            </>
          )}
          {storeProduct?.productDescription?.length > 0 &&
          <div className='text-sm text-black text-opacity-75 mb-4'>{storeProduct.productDescription}</div>}
          {storeProduct.haveVariants && <>Variants</>}
          {storeProduct.haveVariants ? (
            storeProduct.productVariants.map((variants) => (
              <div key={variants.id}>
                <figure className="flex flex-col gap-4 sm:flex-row py-4 bg-slate-100 px-4 my-4 rounded-lg  justify-between w-full items-center">
                  <div className="flex flex-row">
                    <div className="w-28 h-28 rounded-lg mx-auto flex-none">
                      <ImageComponent
                        src={variants?.variantPictures?.length > 0 ? getImageUrl(variants?.variantPictures[0]) : ''}
                        htmlClass="w-28 h-28 rounded-lg flex-none"
                        htmlAlt={variants?.variantName}
                      />
                    </div>
                    <div className="pt-2 text-left pl-4">
                      <h3 className="font-medium overflow-ellipsis line-clamp-2">
                        {storeProduct?.productName} {variants?.variantName}
                      </h3>
                      <p className="font-normal text-sm">{`In stock: ${variants?.quantity} ${storeProduct?.productUnit?.productUnitName}`}</p>
                      <p className="font-medium text-primaryViolet mt-2">{`${formatAmount(variants?.sellingPrice)}`}</p>
                    </div>
                  </div>
                  <div className="flex-none w-full sm:w-24">
                    <ProductVariantAddButton product={storeProduct} variantId={variants.id} />
                  </div>
                </figure>
              </div>
            ))
          ) : (
            <ProductAddButton product={storeProduct} isLarge={true} />
          )}
        </div>
      </div>
    </NavigationShell>
  );
};
